import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import "./PurchaseHistory.css";
import { X, History, ChevronRight } from "lucide-react";
import "../promotiondetail/PromotionDetail";
import PromotionDetail from "../promotiondetail/PromotionDetail";
import ApiService from "../../components/Api_services";
import CustomDropdown from "../../components/customdropdown_v2/CustomDropdown";

const PurchaseHistory = ({ onClose, pricingtype, item_id, bundle_id }) => {
  const [showPromotionDetail, setShowPromotionDetail] = useState(false);
  const [allBranchOptions, setAllBranchOptions] = useState([
    { value: "", label: "All Branch" },
  ]);
  const [selectedBranch, setSelectedBranch] = useState("");
  // const navigate = useNavigate();
  const modalRef = useRef(null);
  const [historyData, setHistoryData] = useState([]);

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-MY", options);
  };

  useEffect(() => {
    async function fetchBranchList() {
      const branches = await ApiService.getBranchList();
      const options = [
        { value: "", label: "All Branch" },
        ...branches.map((b) => ({
          value: b.branch_id || b.id,
          label: b.branch_name || b.name || b.branch_code,
        })),
      ];
      setAllBranchOptions(options);
    }
    fetchBranchList();
  }, []);

  useEffect(() => {
    async function fetchHistory() {
      const result = await ApiService.getPurchaseHistory(
        item_id,
        selectedBranch,
        pricingtype,
        bundle_id,
      );
      setHistoryData(Array.isArray(result) ? result : []);
    }
    fetchHistory();
  }, [selectedBranch, pricingtype, item_id, bundle_id]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  // Limit history to 10 records
  const displayHistory = Array.isArray(historyData)
    ? historyData.slice(0, 10)
    : [];

  return (
    <div className="purchasehistory_v2">
      <div className="purchasehistory-content_v2" ref={modalRef}>
        <div className="purchasehistory-title-container_v2">
          <div className="purchasehistory-title_v2">
            <div className="purchasehistory-title-icon_v2">
              <History size={16} />
            </div>
            <strong>Purchase History</strong>
            {historyData && historyData.length > 10 && (
              <span
                className="history-note_v2"
                style={{ fontSize: "12px", color: "#666", marginLeft: "10px" }}
              >
                (Showing recent 10 records)
              </span>
            )}
          </div>
          <button className="phclose-button_v2" onClick={onClose}>
            <X size={16} />
          </button>
        </div>

        <div className="branchselect-container_v2">
          Filter by Branch :
          <CustomDropdown
            options={allBranchOptions}
            value={selectedBranch}
            onChange={(val, opt) => setSelectedBranch(val)}
            placeholder="All Branch"
            className="purchasehistory-dropdown_v2"
            popupRef={modalRef}
          />
        </div>

        <div className="purchasehistory-main_v2">
          <div className="purchaselist-firstrow_v2">
            <div className="firstcolumn_v2">PURCHASE DATE</div>
            <div className="secondcolumn_v2">UNIT PRICE (RM)</div>
            <div className="thirdcolumn_v2">QTY</div>
            <div className="fourthcolumn_v2">TOTAL AMOUNT (RM)</div>
            <div className="lastcolumn_v2"></div>
          </div>

          {displayHistory.length > 0 ? (
            displayHistory.map((item, index) => (
              <div key={index} className="purchaselist-row_v2">
                <div className="firstcolumn_v2">
                  {formatDate(item.inserted_date)}
                </div>
                <div className="secondcolumn_v2">
                  <div>
                    {(() => {
                      const promos = (item.promo_name || "")
                        .split(",")
                        .map((p) => p.trim())
                        .filter(Boolean);

                      // Buy X Free Y logic
                      const buyFreePromo = promos.find((p) =>
                        /^Buy\s*\d+\s*Free\s*\d+$/i.test(p),
                      );
                      if (buyFreePromo && item.unit_price) {
                        const match = buyFreePromo.match(
                          /Buy\s*(\d+)\s*Free\s*(\d+)/i,
                        );
                        if (match) {
                          const X = parseInt(match[1], 10);
                          const Y = parseInt(match[2], 10);
                          if (X > 0 && Y > 0) {
                            const discounted = (item.unit_price * X) / (X + Y);
                            return formatCurrency(discounted);
                          }
                        }
                      }

                      // Default
                      return item.unit_price
                        ? formatCurrency(item.unit_price)
                        : "0.00";
                    })()}
                  </div>
                </div>
                <div className="thirdcolumn_v2">{item.qty}</div>
                <div className="fourthcolumn_v2" style={{ fontWeight: "600" }}>
                  <div>
                    {(() => {
                      const promos = (item.promo_name || "")
                        .split(",")
                        .map((p) => p.trim())
                        .filter(Boolean);

                      // Buy X Free Y logic
                      const buyFreePromo = promos.find((p) =>
                        /^Buy\s*\d+\s*Free\s*\d+$/i.test(p),
                      );
                      if (buyFreePromo && item.unit_price) {
                        const match = buyFreePromo.match(
                          /Buy\s*(\d+)\s*Free\s*(\d+)/i,
                        );
                        if (match) {
                          const X = parseInt(match[1], 10);
                          const Y = parseInt(match[2], 10);
                          if (X > 0 && Y > 0) {
                            const discounted = (item.unit_price * X) / (X + Y);
                            return formatCurrency(discounted * item.qty);
                          }
                        }
                      }

                      // Default
                      return item.unit_price
                        ? formatCurrency(item.unit_price * item.qty)
                        : "0.00";
                    })()}
                  </div>
                </div>
                <div className="lastcolumn_v2">
                  {item.so_id ? (
                    <Link
                      to={`/orderdetail/${item.so_id}`}
                      className="purchaselist-row-icon_v2"
                      target="_blank"
                      style={{
                        cursor: "pointer",
                        opacity: 1,
                        textDecoration: "none",
                        color: "inherit",
                      }}
                      title="View sales order detail"
                    >
                      <ChevronRight size={16} />
                    </Link>
                  ) : (
                    <div
                      className="purchaselist-row-icon_v2"
                      style={{
                        cursor: "not-allowed",
                        opacity: 0.5,
                      }}
                      title="No invoice available"
                    >
                      <ChevronRight size={16} />
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div
              className="purchaselist-row_v2"
              style={{ padding: "12px 24px" }}
            >
              No purchase history found
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PurchaseHistory;
